import positiveReportFormReducer from "./positiveReportFormReducer";

const positiveReportReducers = {
    positiveReportForm: positiveReportFormReducer
};

export default positiveReportReducers;